export default __webpack_public_path__ + "static/media/InsideGerms_08.95824c9b.png";